import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";

function RootRedirect() {
  const loc = useLocation();
  let target = "/en";
  if (typeof navigator !== "undefined") {
    const langs = navigator.languages || [navigator.language || ""];
    if (langs.some((l) => l.toLowerCase().startsWith("uk"))) target = "/uk";
  }
  return <Navigate to={`${target}${loc.hash || ""}${loc.search || ""}`} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/en" element={<Landing lang="en" />} />
          <Route path="/uk" element={<Landing lang="uk" />} />
          <Route path="*" element={<Navigate to="/en" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
